import React, { forwardRef } from 'react';

import { TournamentProvider } from '@atlas/core';
import { SimpleTournamentSkeleton, ViewportDisplayController } from '@atlas/ui';

import Tournament from './SimplifiedTournament';

const SimpleTournamentPlaceholder = forwardRef((props, ref) => {
  return (
    <div className="tournament placeholder" ref={ref}>
      <SimpleTournamentSkeleton {...props} />
    </div>
  );
});

const SimplifiedTournaments = ({ tournaments }) => {
  return tournaments?.map(tournament => (
    <ViewportDisplayController
      eventsNumber={3}
      key={tournament.id}
      outcomesNumber={1}
      placeholder={SimpleTournamentPlaceholder}
    >
      <TournamentProvider key={tournament.id} tournament={tournament}>
        <Tournament tournament={tournament} />
      </TournamentProvider>
    </ViewportDisplayController>
  ));
};

export default SimplifiedTournaments;
